module.exports = "<h2 class=\"header-major\">Create A New Template</h2>\r\n<app-thought-form\r\n  [thought]=\"template\"\r\n  isTemplateForm=\"true\"\r\n  (templateSaved)=\"templateSaved($event)\"\r\n  (templateCancelled)=\"templateCancelled($event)\"\r\n  (templateDeleted)=\"templateDeleted($event)\"></app-thought-form>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/Alec/Documents/dev/recog/recog/src/app/thought-module/thought-template/template-create/template-create.component.html
// module id = ../../../../../src/app/thought-module/thought-template/template-create/template-create.component.html
// module chunks = main